// this is an autogenerated file from App/Account/Search/Content/Profiles/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Search_Content_Profiles(
  $query: String!
  $whole_parent_company: Boolean!
  $include_leads: Boolean!
  $parent_company_id: uuid!
  $is_new_search_enabled: Boolean!
  $entity_types: [search_entity_types_enum!]!
) {
  search_search(
    args: { query: $query, whole_parent_company: $whole_parent_company }
    where: { type: { _in: $entity_types } }
    limit: 20
  ) @include(if: $is_new_search_enabled) {
    lead {
      id
      first_name
      last_name
      email
      metadata
      birth_date
      phone_number
    }
    person {
      id
      first_name
      last_name
      greeting
      gender
      birth_date
      profile_pic_url
      public_user {
        id
      }
      person_payment_account {
        id
      }
      phones: contact_method_associations(
        where: {
          contact_method: {
            dtype: { _eq: "phone" }
            phone: { type: { _eq: "CELL" } }
          }
        }
      ) {
        id
        description
        contact_method {
          id
          phone {
            id
            number
          }
        }
      }
      patient {
        id
        _id
        human_readable_id
        legacy_id
      }
      from_person_relationships {
        id
        role
        to_person_record {
          id
          first_name
          last_name
          profile_pic_url
          gender
          birth_date
          patient {
            id
            _id
          }
        }
      }
      employment_contracts(
        where: {
          employment_end_date: { _is_null: true }
          deleted: { _eq: false }
        }
      ) {
        id
      }
      other_professional_relationships(order_by: { sys_created: desc }) {
        id
        employee_type {
          id
          name
        }
        external_office {
          id
          name
          postal_address {
            id
            state
          }
        }
      }
    }
  }

  vaxiom_persons_search(
    search_term: $query
    parent_company_id: $parent_company_id
    whole_parent_company: $whole_parent_company
    include_leads: $include_leads
  ) @skip(if: $is_new_search_enabled) {
    lead {
      id
      first_name
      last_name
      email
      metadata
      birth_date
      phone_number
    }
    person: vaxiom_person {
      id
      first_name
      last_name
      greeting
      gender
      birth_date
      profile_pic_url
      public_user {
        id
      }
      person_payment_account {
        id
      }
      phones: contact_method_associations(
        where: {
          contact_method: {
            dtype: { _eq: "phone" }
            phone: { type: { _eq: "CELL" } }
          }
        }
      ) {
        id
        description
        contact_method {
          id
          phone {
            id
            number
          }
        }
      }
      patient {
        id
        _id
        human_readable_id
        legacy_id
      }
      from_person_relationships {
        id
        role
        to_person_record {
          id
          first_name
          last_name
          profile_pic_url
          gender
          birth_date
          patient {
            id
            _id
          }
        }
      }
      employment_contracts(
        where: {
          employment_end_date: { _is_null: true }
          deleted: { _eq: false }
        }
      ) {
        id
      }
      other_professional_relationships(order_by: { sys_created: desc }) {
        id
        employee_type {
          id
          name
        }
        external_office {
          id
          name
          postal_address {
            id
            state
          }
        }
      }
    }
  }
}

`